<template lang="html">
  <div id="floorplan-panoramic-view" class="mv5" :class="{'active': loaded}">
    <div id="viewCanvas" class="w-80 center" :style="{'background-image': 'url(' + viewUrl + ')'}"></div>

    <!-- Label -->
    <div class="ttu mv3 b f4">
      {{ dir }} VIEW FROM LEVEL {{ view.floor }}
    </div>
  </div>
</template>

<script>
/* global Impetus */
import FloorplanMixin from '../FloorplanMixin';

export default {
  name: 'floorplan-panoramic-view',
  mixins: [FloorplanMixin],
  props: {
    plan: {
      type: Object,
      default: () => ({})
    },
    view: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      impetus: null,
      loaded: false
    };
  },
  computed: {
    dir() {
      switch (this.view.dir) {
        case 'n':
          return 'NORTH';
        case 'e':
          return 'EAST';
        case 's':
          return 'SOUTH';
        case 'w':
          return 'WEST';
        default:
          return 'n';
      }
    },
    viewUrl() {
      return this.baseUrl + this.view.src;
    }
  },
  methods: {
    initPanoramicImage() {
      const canvas = document.getElementById('viewCanvas');
      const boundXmin = -((this.viewImage.width / this.viewImage.height) * canvas.clientHeight) + canvas.clientWidth;
      if (this.impetus) {
        this.impetus.destroy();
      }

      const initialY = 0;
      let initialX = 0;
      switch (this.dir) {
        case 'EAST':
          initialX = boundXmin;
          break;
        case 'SOUTH':
          initialX = 0;
          break;
        case 'NORTH':
          initialX = (boundXmin - canvas.clientWidth) / 2;
          break;
        default: // WEST
          initialX = 0;
      }

      this.impetus = new Impetus({
        source: canvas,
        friction: 0.96,
        multiplier: 1.2,
        bounce: false,
        boundX: [boundXmin, 0],
        boundY: [0, 0],
        initialValues: [initialX, initialY],
        update: (x) => {
          canvas.style.backgroundPosition = `${x}px 0px`;
        }
      });

      this.loaded = true;
    }
  },
  created() {
    this.viewImage = new Image();
    this.viewImage.onload = this.initPanoramicImage;
    this.viewImage.src = this.viewUrl;
  },
  beforeDestroy() {
    if (this.impetus) {
      this.impetus.destroy();
    }
  },
  watch: {
    view() {
      if (this.view) {
        this.loaded = false;
        const img = new Image();
        img.onload = () => {
          this.loaded = true;
        };
        img.src = this.baseUrl + this.view.src;
        this.viewImage.src = this.viewUrl;
      }
    }
  }
};
</script>

<style lang="scss">
#floorplan-panoramic-view {
  opacity: 0;
  transition: opacity 0.25s ease-out;
  &.active { opacity: 1; }

  #viewCanvas {
    background-position: center center;
    background-size: auto 100%;
    height: 300px;
    max-width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanDetail/FloorplanPanoramicView.vue